module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.name) ? _c('h3', [_vm._v("\n    Currently working on: "), _c('span', {
    staticClass: "filename"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    staticClass: "filetype"
  }, [_vm._v(_vm._s(_vm.arrayBuffer ? "PDF" : "image"))])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("If you want to zoom in/out, you'll need to use your browser zoom for the moment.")]), _vm._v(" "), (_vm.src || _vm.arrayBuffer) ? _c('div', {
    ref: "selectionArea",
    staticClass: "selection-area",
    on: {
      "mousedown": _vm.start,
      "mouseup": _vm.end,
      "mousemove": _vm.drag
    }
  }, [(_vm.src) ? _c('img', {
    attrs: {
      "src": _vm.src
    }
  }) : _vm._e(), _vm._v(" "), (_vm.arrayBuffer) ? _c('PDF', {
    attrs: {
      "setPdfSize": _vm.setPdfSize,
      "arrayBuffer": _vm.arrayBuffer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.arrayBuffer) ? _c('SelectionPreview', {
    attrs: {
      "coordinates": _vm.coordinates
    }
  }) : _vm._e(), _vm._v(" "), _c('AreaSelect', {
    ref: "activeSelector",
    attrs: {
      "coordinates": _vm.coordinates,
      "color": "rgb(0,255,0)",
      "active": "true"
    }
  }), _vm._v(" "), _vm._l((_vm.selections), function(selection) {
    return _c('AreaSelect', {
      key: selection.id,
      attrs: {
        "color": selection.color,
        "coordinates": selection.coordinates,
        "name": selection.name
      }
    })
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-557e482b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Annotator.vue
// module id = 95
// module chunks = 2